const getLocationOrigin = () => {
    //return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
    return 'https://tg.mtxll.top'
  }
  const url='https://tg.mtxll.top'
  const urlImg='https://tg.mtxll.top'
  const companyName = '满天星文化'
  const version = 'V1.0.0'
  const baiduKey = '百度key'
  const cacheFix='mtx_'
  
  export default {
    url,
    version,
    companyName,
    getLocationOrigin,
    baiduKey,
    cacheFix
  }
  